// libs
import { styled } from '@nykaa/ui-components';

// components
// Icon is now passed from parent component for store-awareness

// animation
import { fadeInAnimation } from 'shared/styles/animations/fadeIn';
import { MWEB_HEADER_ZINDEX } from 'shared/styles/base';

export const TopContainer = styled.div`
  z-index: ${MWEB_HEADER_ZINDEX - 8};
  animation: ${fadeInAnimation} 0.6s ease-in forwards;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Container = styled.div`
  min-width: 260px;
  min-height: 120px;
  ${({ theme }) => `
   background: ${theme.colors.surfaceInverse20};
   padding: ${theme.spacing.spacing80};
   border-radius: ${theme.borders.radius35};
   box-shadow: ${theme.elevations.shadow300};
  `}
  display: flex;
  flex-flow: column;
  left: 10%;
`;

export const DescriptionContainer = styled.div`
  display: flex;
  height: 56px;
`;

export const Icon = styled.div`
  height: 40px;
  min-width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => `
    border-radius: ${theme.borders.radius50};
    background-color: ${theme.colors.surface};
  `}
  overflow: hidden;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-flow: column;
  text-align: left;
`;

export const Title = styled.p`
  margin: 0;
  ${({ theme }) => `
    margin-left: ${theme.spacing.spacing60};
    color: ${theme.colors.surface};
  `}

  ${({ theme }) => theme.typography.subTitleMedium};
`;

export const Description = styled.p`
  margin: 0;
  ${({ theme }) => `
    margin-left: ${theme.spacing.spacing60};
    margin-top: ${theme.spacing.spacing20};
    color: ${theme.colors.surface};
  `}
  ${({ theme }) => theme.typography.bodySmall};
`;

export const Footer = styled.div`
  height: 20px;
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing.spacing80};
`;

export const CTAContainer = styled.div`
  height: 20px;
  ${({ theme }) => theme.typography.buttonMedium};
  color: ${({ theme }) => theme.colors.secondaryInverse};
  cursor: pointer;
`;

export const StepContainer = styled.div`
  height: 20px;
  ${({ theme }) => theme.typography.buttonMedium};
  color: ${({ theme }) => theme.colors.textInverseDisabled};
`;

export const Pointer = styled.div`
  width: 24px;
  height: 24px;
  border-top-left-radius: 6px;
  position: relative;
  left: 24px;
  background: ${({ theme }) => theme.colors.surfaceInverse20};
  transform: rotate(45deg);
  top: 12px;
`;

export const CircleXDuoToneIcon = styled.div < { circleFill?: string; }> `
  ${(props) => (props.circleFill ? `circle { fill-opacity: 0.64; fill: ${props.circleFill}};` : '')}
`;
